import { gql } from '@apollo/client';

const smsQuery = (payload: any) =>
 gql`
  
   query smsQuery 
    {
      getFile
        (
          token: "${payload.token}"
          accountNumber: "${payload.accountNumber}"
        ) 
      {
        file
        error
        {
          # code
          message
        }
      }
    }
  
`;

export { smsQuery };
